"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DataStorageManager_1 = __importDefault(require("../../data/DataStorageManager"));
class MusicInfoBlock {
    constructor() {
        this.container = this.createContainer();
        // 3 div setting
        this.keyDiv = this.createEditableDiv("key");
        this.titleDiv = this.createEditableDiv("title");
        this.composerDiv = this.createEditableDiv("composer");
        this.keyDiv.setAttribute("data-placeholder", "Key & Tempo");
        this.titleDiv.setAttribute("data-placeholder", "Title");
        this.composerDiv.setAttribute("data-placeholder", "Composer");
        this.container.appendChild(this.keyDiv);
        this.container.appendChild(this.titleDiv);
        this.container.appendChild(this.composerDiv);
    }
    createContainer() {
        const container = document.createElement("div");
        container.className = "musicInfo-block";
        return container;
    }
    createEditableDiv(id) {
        const div = document.createElement("div");
        // basic 
        div.className = "musicInfo-item";
        div.setAttribute("contentEditable", "true");
        div.setAttribute("data-store", "musicInfo");
        div.id = id;
        div.textContent = "";
        div.setAttribute("spellcheck", "false");
        // init() to global array
        DataStorageManager_1.default.updateData(div.id, { id: div.id, value: div.textContent });
        return div;
    }
    getElement() {
        return this.container;
    }
}
exports.default = MusicInfoBlock;
// ^^^^^^^^^ check! 2024/11/19 ^^^^^^^^
